import React from "react";
import { Text } from "@networkraildigitalfactory/components";

const Message = (props) => {
  const { status, isLineManager, fullName } = props;
  const getMessage = () => {
    switch (status) {
      case "completed":
        return isLineManager
          ? `This 1-2-1 has been marked as complete. You can add comments below if you wish.`
          : `These are the notes from your completed 1-2-1 with your line manager.`;
      default:
        return isLineManager
          ? `You’ll find ${fullName}’s notes for this 1-2-1 below. You can start the 1-2-1 by selecting ‘Begin 1-2-1’.`
          : `These notes can be edited up until your 1-2-1 with your line manager.`;
    }
  };

  const message = getMessage();

  return (
    <Text wrapper="span" type="body">
      {message}
    </Text>
  );
};

export default Message;
